import { render, staticRenderFns } from "./PostalCodeInput.vue?vue&type=template&id=58acc2f4&scoped=true"
import script from "./PostalCodeInput.vue?vue&type=script&lang=js"
export * from "./PostalCodeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58acc2f4",
  null
  
)

export default component.exports